import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = [];
class AccountChooserController {

    constructor() {

        this.myId = MeRepository.getMyId();

    }

    mixpClickHdlAnon(element) {

        const elmToName = {
            login: 'Login',
            register: 'Registration',
        };

        if (elmToName[element]) {

            if (this.myId) {

                Mixpanel.send(`Dashboard Home Click ${elmToName[element]}`);

            } else {

                const source = (element === 'Registration') ? 'Register Button' : 'Dashboard';
                const msg = `Anonymous Dashboard ${elmToName[element]} Click`;

                Mixpanel.send(msg, { Source: source });

            }

        }

    }

}

class AccountChooserDirective {

    constructor() {

        this.template = require('./account-chooser.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(() =>
            new AccountChooserController());
        this.controller = _controllerDependencies;
        this.controllerAs = 'accountChooserCtrl';

    }

}

_directiveDependencies.push(() => new AccountChooserDirective());

angular.module('directives')
    .directive('accountChooser', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/header/account-chooser/account-chooser.js